import { useQuery } from '@tanstack/react-query';
import { getAvailableAccountRequest } from './model/request/getAvailableAccountRequest';
import getAvailableAccount from 'Api/schedule-ruleset/getAvailableAccount';
import getAvailableAccountResponse from './model/response/getAvailableAccountResponse';

const useGetAvailableAccount = ({ queryParams, rulesetDetail, enabled }) => {
  return useQuery({
    queryKey: ['ruleset-account', queryParams],
    queryFn: async () => {
      const queries = getAvailableAccountRequest(queryParams);

      const response = await getAvailableAccount(queries);

      const result = getAvailableAccountResponse(response, rulesetDetail);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled,
  });
};

export default useGetAvailableAccount;
